import { render, staticRenderFns } from "./OpenedListItem.vue?vue&type=template&id=fcfc8870&"
import script from "./OpenedListItem.vue?vue&type=script&lang=js&"
export * from "./OpenedListItem.vue?vue&type=script&lang=js&"
import style0 from "./OpenedListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports